  (function () {
    class ImageGallery {
      constructor() {
        this.gallery = document.querySelector('.gallery-container');
        if (!this.gallery) return;

        this.mainImage = this.gallery.querySelector('.main-branch-image');
        this.thumbnails = Array.from(this.gallery.querySelectorAll('.thumbnail-item'));

        if (!this.mainImage || !this.thumbnails.length) return;

        this.currentIndex = 0;
        this.transitionDuration = 300; // ms
        this.isAnimating = false;

        this.init();
      }

      init() {
        this.setupEventListeners();
        // No thumbnail selected by default
        this.thumbnails.forEach((thumb) => {
          thumb.setAttribute('tabindex', '0');
          thumb.classList.remove('thumb-active');
        });
      }

      setupEventListeners() {
        // Use event delegation for better performance
        this.gallery.addEventListener('click', (e) => {
          const thumb = e.target.closest('.thumbnail-item');
          if (!thumb) return;

          e.preventDefault();
          this.handleThumbnailClick(thumb);
        });

        // Keyboard navigation
        this.gallery.addEventListener('keydown', (e) => {
          const thumb = e.target.closest('.thumbnail-item');
          if (!thumb) return;

          const currentIndex = this.thumbnails.indexOf(thumb);

          switch (e.key) {
            case 'Enter':
            case ' ':
              e.preventDefault();
              this.handleThumbnailClick(thumb);
              break;

            case 'ArrowRight':
              e.preventDefault();
              this.navigateTo((currentIndex + 1) % this.thumbnails.length);
              break;

            case 'ArrowLeft':
              e.preventDefault();
              this.navigateTo((currentIndex - 1 + this.thumbnails.length) % this.thumbnails.length);
              break;
          }
        });
      }

      handleThumbnailClick(thumb) {
        if (this.isAnimating || !thumb) return;

        const img = thumb.querySelector('img');
        if (!img?.dataset?.fullSize) return;

        this.updateMainImage(img);
        this.updateActiveThumb(thumb);
      }

      updateMainImage(newImage) {
        if (!newImage) return;

        this.isAnimating = true;
        this.mainImage.style.opacity = '0';

        // Preload the new image
        const imgPreload = new Image();
        imgPreload.src = newImage.dataset.fullSize;

        imgPreload.onload = () => {
          this.mainImage.src = newImage.dataset.fullSize;
          this.mainImage.srcset = newImage.dataset.srcset || '';
          this.mainImage.alt = newImage.alt || '';

          // Fade in the new image
          requestAnimationFrame(() => {
            this.mainImage.style.opacity = '1';
            this.isAnimating = false;
          });
        };

        // Fallback in case of image load error
        imgPreload.onerror = () => {
          console.error('Failed to load image:', newImage.dataset.fullSize);
          this.isAnimating = false;
        };
      }

      updateActiveThumb(thumb) {
        this.thumbnails.forEach((t) => t.classList.remove('thumb-active'));
        thumb.classList.add('thumb-active');
        this.currentIndex = this.thumbnails.indexOf(thumb);
      }

      navigateTo(index) {
        if (index < 0 || index >= this.thumbnails.length) return;

        const thumb = this.thumbnails[index];
        if (!thumb) return;

        this.handleThumbnailClick(thumb);
        thumb.focus();
      }
    }

    // Initialize the gallery when the DOM is fully loaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => new ImageGallery());
    } else {
      new ImageGallery();
    }
  })();